import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';
import { config } from './config';

export type AppRouter = any;

export type GetTokenFn = () => Promise<string | null>;

/**
 * Create a tRPC client that uses getToken for Authorization header.
 * Must be called with getToken from the host app (e.g. useAuthContext().getToken).
 */
export function createTrpcClient(getToken: GetTokenFn) {
  return createTRPCProxyClient<AppRouter>({
    links: [
      httpBatchLink({
        url: `${config.api.baseUrl}/trpc`,
        fetch: (url, options) => {
          return fetch(url, {
            ...options,
            credentials: 'omit',
          });
        },
        headers: async () => {
          const token = await getToken();
          return {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          };
        },
      }),
    ],
  });
}

export type RouterInputs = any;
export type RouterOutputs = any;
